
<div>
  <mat-toolbar style="background-color: #92D3E1; height: 35px;">
      <div style="width: 100%; display: inline-flex; justify-content: space-between;">
          <h2 style="color: black; font-weight: 400;">Application Alert</h2>

          <img style="float: right;cursor: pointer;" class="close" (click)="closeMaintenanceBanner()" src="assets/images/wow-circled-x-icon.svg" alt="close">
      </div>
  </mat-toolbar>
  <mat-dialog-content>
      <div class="md-dialog-content user-role-dialog-content"  *ngIf="appMaintenanceObj.maintenanceMsg">

          <span style="color: black; font-size: 14px;">{{appMaintenanceObj.maintenanceMsg}}</span>
      </div>
  </mat-dialog-content>


  <mat-dialog-actions style="margin-bottom: -4px;  padding-right: 10px;">
      <button class="sec-button-21" style="margin-left:15px;" *ngIf="isReleaseNoteAvailable" (click)="showReleaseNotes()">RELEASE NOTES</button>
      <button class="prim-button-2" style="margin-left:180px;" (click)="dismissMaintenanceBanner()">DISMISS</button>
      <button class="sec-button-2" style="margin-left:10px;" (click)="closeMaintenanceBanner()">CLOSE</button>
  </mat-dialog-actions>


<mat-dialog-content class="content">
  <div class="md-dialog-content user-role-dialog-content" style="padding-top: 12px;padding-right: 20px;overflow-y: scroll;
  height: 80px;
  border-top: solid 1px;font-size: 14px;" *ngIf="releaseNoteFlag">
  <ul>
    <li *ngFor="let notes of appMaintenanceReleaseNote" style="margin-bottom: 10px;">
      {{notes}}
    </li>
  </ul>
  </div>
</mat-dialog-content>
</div>
